import { api, type ApiType } from 'lib/api';
import { stringParse } from 'utils';

export const apiAdminUnits: ApiType = {
  get: {
    list: () => api.get('/api/adminunits'),
    byId: ({ vars }) => api.get(stringParse('/api/adminunits/{0}', vars)),
  },
  put: {
    update: ({ vars, data }) => api.put(stringParse('/api/adminunits/{0}', vars), data),
  },
  post: {
    create: ({ data }) => api.post('/api/adminunits', data),
  },
  delete: {
    remove: ({ vars }) => api.delete(stringParse('/api/adminunits/{0}', vars)),
  },
};
